var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBikeSeat = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 542,
  height: 619,
  viewBox: "0 0 542 619",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#003BB1",
  fillRule: "evenodd",
  d: "M304.109 102.897Q261.189 11.13 201.787 1.05 123.259-6.5 97.717 84.25q-4.46 43.346-4.46 130.747T63.702 367.568Q.28 478.957.28 501.148c0 22.194 9.588 147.886 244.843 110.384Q463.54 548.07 532.189 372.96q38.572-130.637-88.583-165.549Q316.451 172.5 304.11 102.897"
})));
export default SvgBikeSeat;